import {
  Footer,
  ClearAllButton,
  DiscardButton,
  MainActionButton,
} from './ModalFooter.styled';
import { ModalFooterProps } from './ModalFooter.types';

export const ModalFooter = ({
  clearAllCB,
  clearAllLabel,
  discardCB,
  discardLabel,
  mainActionCB,
  mainActionLabel,
}: ModalFooterProps) => {
  return (
    <Footer>
      <ClearAllButton onClick={clearAllCB}> {clearAllLabel} </ClearAllButton>
      <DiscardButton onClick={discardCB}> {discardLabel} </DiscardButton>
      <MainActionButton onClick={mainActionCB}>
        {mainActionLabel}
      </MainActionButton>
    </Footer>
  );
};
